<h3 [id]="this.idVal" class="st-header-title-field"
    [ngStyle]="{
          'color': color
       }"
>{{inputVal}}</h3>
